
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.612 10.633c.139.135.261.259.367.367a20.946 20.946 0 01-2.643 2.288C16.4 14.695 13.806 16.04 11 16.04s-5.4-1.345-7.336-2.752A20.958 20.958 0 011.021 11a20.963 20.963 0 012.643-2.288C5.6 7.305 8.194 5.961 11 5.961s5.4 1.344 7.336 2.75c.96.699 1.738 1.398 2.276 1.921z","stroke":"#000","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M8.276 11a2.724 2.724 0 115.448 0 2.723 2.723 0 11-5.447 0z","stroke":"#000","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M3 17L19 5","stroke":"#000","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    